import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    "ScreenshotRow",
    "RateValue", "RateForm",
    "RateNotesValue", "RateNotesForm",
    "UnitPriceValue", "UnitPriceForm", "ListingForm",
    "TruckTypeValue", "TruckTypeForm",
    "EmailSelectionColumn", "EmailSelectionCell", "EmailSelectionInput"
  ]

  get truckload_order_controller() {
    return document.querySelector(`[data-controller="truckload-order"]`)[`truckload-order`]
  }

  connect() {
    this.element[this.identifier] = this
    this.screenshotsExpanded = []
    this.formsExpanded = []
    this.determineShowCheckboxes()
  }

  determineShowCheckboxes() {
    if (this.truckload_order_controller.showingEmailRateCheckboxes) {
      this.showEmailCheckboxes()
    } else {
      this.hideEmailCheckboxes()
    }
  }

  showEmailCheckboxes() {
    this.EmailSelectionColumnTarget.classList.remove("hidden")
    this.EmailSelectionCellTargets.map((target) => target.classList.remove("hidden"))
  }

  hideEmailCheckboxes() {
    this.EmailSelectionColumnTarget.classList.add("hidden")
    this.EmailSelectionCellTargets.map((target) => target.classList.add("hidden"))
  }

  clearEmailCheckboxes() {
    this.EmailSelectionInputTargets.map((target) => target.checked = false)
  }

  controlForm(rateId, goOpen) {
    rateId = parseInt(rateId)
    let rateValueTarget = this.RateValueTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let rateFormTarget = this.RateFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let rateNotesValueTarget = this.RateNotesValueTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let rateNotesValueFormTarget = this.RateNotesFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let unitPriceValueTarget = this.UnitPriceValueTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let unitPriceFormTarget = this.UnitPriceFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let truckTypeValueTarget = this.TruckTypeValueTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let truckTypeFormTarget = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let listingFormTarget = this.ListingFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)

    if (goOpen) {
      if (rateFormTarget) {
        rateValueTarget.classList.add("hidden")
        rateNotesValueTarget.classList.add("hidden")
        rateFormTarget.classList.remove('hidden')
        rateNotesValueFormTarget.classList.remove('hidden')
      }
      if (unitPriceFormTarget) {
        unitPriceValueTarget.classList.add("hidden")
        unitPriceFormTarget.classList.remove('hidden')
      }
      if (truckTypeFormTarget) {
        truckTypeValueTarget.classList.add("hidden")
        truckTypeFormTarget.classList.remove("hidden")
      }
      if (listingFormTarget) {
        unitPriceValueTarget.classList.add("hidden")
        listingFormTarget.classList.remove("hidden")
      }
      this.formsExpanded.push(rateId)
    } else {
      if (rateFormTarget) {
        rateValueTarget.classList.remove("hidden")
        rateNotesValueTarget.classList.remove("hidden")
        rateFormTarget.classList.add('hidden')
        rateNotesValueFormTarget.classList.add('hidden')
      }
      if (unitPriceFormTarget) {
        unitPriceValueTarget.classList.remove("hidden")
        unitPriceFormTarget.classList.add('hidden')
      }
      if (truckTypeFormTarget) {
        truckTypeValueTarget.classList.remove("hidden")
        truckTypeFormTarget.classList.add("hidden")
      }
      if (listingFormTarget) {
        unitPriceValueTarget.classList.remove("hidden")
        listingFormTarget.classList.add("hidden")
      }
      this.formsExpanded = this.formsExpanded.filter((id) => id != rateId)
    }
  }

  onStopPropagation(e) {
    e.stopPropagation()
  }

  onToggleScreenshot(e) {
    e.stopPropagation()

    let elem = e.currentTarget
    let rateId = elem.dataset.rateId
    let target = this.ScreenshotRowTargets.find((target) => parseInt(target.dataset.rateId) == rateId)

    if (this.screenshotsExpanded.includes(rateId)) {
      target.classList.add('hidden')
      this.screenshotsExpanded = this.screenshotsExpanded.filter((id) => id != rateId)
    } else {
      target.classList.remove('hidden')
      this.screenshotsExpanded.push(rateId)
    }
  }

  onCloseForm(e) {
    let rateId = e.currentTarget.dataset.rateId
    this.controlForm(rateId, this.formsExpanded.includes(rateId))
  }

  onToggleForm(e) {
    e.stopPropagation()

    let elem = e.currentTarget
    let rateId = elem.dataset.rateId

    this.controlForm(rateId, !this.formsExpanded.includes(rateId))
  }

  async onRateSubmit(e) {
    e.preventDefault()

    let form = e.target
    let rateId = e.target.dataset.rateId
    let body = new FormData(form)
    let rateNotesFormTarget = this.RateNotesFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (rateNotesFormTarget) {
      let rateNotesInput = rateNotesFormTarget.querySelector("#truckload_rate_rate_notes")
      body.append("truckload_rate[rate_notes]", rateNotesInput.value)
    }
    let unitPriceFormTarget = this.UnitPriceFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (unitPriceFormTarget) {
      let unitPriceInput = unitPriceFormTarget.querySelector("#truckload_rate_unit_price")
      body.append("truckload_rate[unit_price]", unitPriceInput.value)
    }
    let truckTypeFormTarget = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (truckTypeFormTarget) {
      let truckTypeInput = truckTypeFormTarget.querySelector("#truckload_rate_truck_type")
      body.append("truckload_rate[truck_type]", truckTypeInput.value)
    }

    const request = new FetchRequest('post', form.action, { body: body, responseKind: 'turbo-stream' })
    await request.perform()
  }

  async onRateNotesSubmit(e) {
    e.preventDefault()

    let form = e.target
    let rateId = e.target.dataset.rateId
    let body = new FormData(form)
    let rateFormTarget = this.RateFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (rateFormTarget) {
      let rateInput = rateFormTarget.querySelector("#truckload_rate_rate")
      body.append("truckload_rate[rate]", rateInput.value)
    }
    let unitPriceFormTarget = this.UnitPriceFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (unitPriceFormTarget) {
      let unitPriceInput = unitPriceFormTarget.querySelector("#truckload_rate_unit_price")
      body.append("truckload_rate[unit_price]", unitPriceInput.value)
    }
    let truckTypeFormTarget = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (truckTypeFormTarget) {
      let truckTypeInput = truckTypeFormTarget.querySelector("#truckload_rate_truck_type")
      body.append("truckload_rate[truck_type]", truckTypeInput.value)
    }

    const request = new FetchRequest('post', form.action, { body: body, responseKind: 'turbo-stream' })
    await request.perform()
  }

  async onUnitPriceSubmit(e) {
    e.preventDefault()

    let form = e.target
    let rateId = e.target.dataset.rateId
    let body = new FormData(form)
    let rateFormTarget = this.RateFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (rateFormTarget) {
      let rateInput = rateFormTarget.querySelector("#truckload_rate_rate")
      let rateNotesFormTarget = this.RateNotesFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
      let rateNotesInput = rateNotesFormTarget.querySelector("#truckload_rate_rate_notes")
      body.append("truckload_rate[rate]", rateInput.value)
      body.append("truckload_rate[rate_notes]", rateNotesInput.value)
    }
    let truckTypeFormTarget = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (truckTypeFormTarget) {
      let truckTypeInput = truckTypeFormTarget.querySelector("#truckload_rate_truck_type")
      body.append("truckload_rate[truck_type]", truckTypeInput.value)
    }

    const request = new FetchRequest('post', form.action, { body: body, responseKind: 'turbo-stream' })
    await request.perform()
  }

  async onTruckTypeKeydown(e) {
    e.preventDefault()

    let rateId = e.currentTarget.dataset.rateId
    let form = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let body = new FormData(form)

    let rateFormTarget = this.RateFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (rateFormTarget) {
      let rateInput = rateFormTarget.querySelector("#truckload_rate_rate")
      let rateNotesFormTarget = this.RateNotesFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
      let rateNotesInput = rateNotesFormTarget.querySelector("#truckload_rate_rate_notes")
      body.append("truckload_rate[rate]", rateInput.value)
      body.append("truckload_rate[rate_notes]", rateNotesInput.value)
    }
    let unitPriceFormTarget = this.UnitPriceFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (unitPriceFormTarget) {
      let unitPriceInput = unitPriceFormTarget.querySelector("#truckload_rate_unit_price")
      body.append("truckload_rate[unit_price]", unitPriceInput.value)
    }

    const request = new FetchRequest('post', form.action, { body: body, responseKind: 'turbo-stream' })
    await request.perform()
  }

  async clearOtherSelectedRateCheckboxes(e) {
    let rateId = e.target.dataset.truckloadRateId
    this.EmailSelectionInputTargets.filter((target) => target.dataset.truckloadRateId != rateId).map((target) => target.checked = false)
  }

  async onDeliveredPriceEmailTlRateChange(e) {
    e.stopPropagation()

    let elem = e.currentTarget
    let form = elem.parentNode
    let body = new FormData(form)

    this.truckload_order_controller.onRateCheckboxChange(e)

    if (this.truckload_order_controller.showingDeliveredPriceEmailForm) {
      if (e.target.checked) {
        body.append("delivered_price_email[add_truckload_rate_id]", e.target.value)
      } else {
        body.append("delivered_price_email[remove_truckload_rate_id]", e.target.value)
      }

      const request = new FetchRequest('put', form.action, { body: body, responseKind: 'turbo-stream' })
      await request.perform()
    }
  }

  async onListingKeydown(e) {
    e.preventDefault()

    let rateId = e.currentTarget.dataset.rateId
    let form = this.ListingFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    let body = new FormData(form)

    let truckTypeFormTarget = this.TruckTypeFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (truckTypeFormTarget) {
      let truckTypeInput = truckTypeFormTarget.querySelector("#truckload_rate_truck_type")
      body.append("truckload_rate[truck_type]", truckTypeInput.value)
    }
    let rateFormTarget = this.RateFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
    if (rateFormTarget) {
      let rateInput = rateFormTarget.querySelector("#truckload_rate_rate")
      let rateNotesFormTarget = this.RateNotesFormTargets.find((target) => parseInt(target.dataset.rateId) == rateId)
      let rateNotesInput = rateNotesFormTarget.querySelector("#truckload_rate_rate_notes")
      body.append("truckload_rate[rate]", rateInput.value)
      body.append("truckload_rate[rate_notes]", rateNotesInput.value)
    }

    const request = new FetchRequest('post', form.action, { body: body, responseKind: 'turbo-stream' })
    await request.perform()
  }

}